// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSyncOutlinedSvg from "@fishx/icons-svg/es/asn/PSyncOutlined";
import FishxIcon from '../components/FishxIcon';

var PSyncOutlined = function PSyncOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSyncOutlinedSvg
  }));
};

PSyncOutlined.displayName = 'PSyncOutlined';
export default React.forwardRef(PSyncOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSyncOutlined.js
// module id = 3669
// module chunks = 0